import { Component, computed, effect, inject, signal, untracked } from '@angular/core';
import { TopBannerService } from '@core/services';
@Component({
  selector: 'lib-top-banner',
  standalone: true,
  templateUrl: './top-banner.component.html',
  styleUrls: ['./top-banner.component.scss'],
})
export class TopBannerComponent {

  readonly #bannerService = inject(TopBannerService);

  state = this.#bannerService.state;

  private lastType = signal<'success' | 'info' | 'error'>('info');

  constructor() {
    effect(() => {
      const s = this.state();
      if (s) {
        untracked(() => this.lastType.set(s.messageType));
      }
    });
  }

  isVisible = computed(() => this.state() !== null);

  message   = computed(() => this.state()?.message ?? '');

  color = computed(() => {
    switch (this.lastType()) {
      case 'success': return '#008200';
      case 'error':   return '#d62d0a';
      default:        return '#00095b';
    }
  });

  iconSrc = computed(() => {
    switch (this.lastType()) {
      case 'success': return './assets/lib/icons/green-circle-check.svg';
      case 'error':   return './assets/lib/icons/red-circle-x.svg';
      default:        return './assets/lib/icons/blue-circle-i.svg';
    }
  });
}